import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaginationMeta } from '@app/shared/interfaces';
import { Filter } from '@app/shared/models/filter';
import { LogService, LogStatus } from '@app/shared/services/logs/log.service';
import { TitleService } from '@app/shared/services/title/title.service';

@Component({
  standalone: false,
  selector: 'sbnb-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss'],
})
export class LogsComponent implements OnInit {
  logStatus = LogStatus;
  logs: any[];
  loading: boolean;
  paginationData: PaginationMeta;
  searchCriteria: string;
  currentOffset: number;
  activeFilters: Filter[];

  constructor(
    private logService: LogService,
    private titleService: TitleService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit() {
    // retrieve record offset from the URL matrix param
    this.currentOffset = +this.route.snapshot.paramMap.get('offset') || 0;

    this.titleService.manuallySet('Operations Logs');
    this.searchCriteria = this.route.snapshot.paramMap.get('query');

    this.loadLogs(this.activeFilters, this.currentOffset, this.searchCriteria);
  }

  loadLogs(filters: Filter[], offset?: number, search?: string) {
    this.loading = true;
    this.logService.getOperationsLogs(offset, search).subscribe((res) => {
      this.logs = res.data;
      this.paginationData = res.meta?.pagination;
      this.loading = false;
    });
  }

  public searchUpdated(searchVal: string) {
    // This is already debounced by the child presentation component
    const url = this.router.createUrlTree([{ query: searchVal }], { relativeTo: this.route }).toString();

    this.location.go(url);

    this.searchCriteria = searchVal;

    this.loadLogs(this.activeFilters, 0, this.searchCriteria);
  }

  openLogDetail(log) {
    this.router.navigate(['/operations/log', log.uuid]);
  }

  public handlePageChanged(newPageNo: number) {
    this.currentOffset = newPageNo;

    // We use offsets as the API deals in offsets rather than pages, when requesting data
    const newOffset = newPageNo * this.paginationData.per_page - this.paginationData.per_page;

    // Commit the new offset to the URL - our source of truth for offsets
    const url = this.router
      .createUrlTree(
        [
          {
            offset: newOffset,
            query: this.searchCriteria ? this.searchCriteria : '',
          },
        ],
        { relativeTo: this.route }
      )
      .toString();

    this.location.go(url);
    this.titleService.manuallySet('Custom codes');

    // Reload Conversation Threads based on new offset data, with existing filters
    this.loadLogs(this.activeFilters, newOffset, this.searchCriteria);
  }
}
